export let projects = [
  {
    name: "Smart Building Dashboards",
    desc: "Architected a real-time IoT building telemetry dashboard processing 200K+ weekly data points from 500+ connected smart buildings. Designed high-performance plugin-based widgets and optimized API query latency by 60%.",
    tags: ["System Design", "Golang", "AWS", "Angular", "IoT Integration"],
    link: "https://www.siemens.com/en-us/products/building-x/applications/data-visualizer/",
  },
  {
    name: "Smart Building Reporting",
    desc: "Designed an event-driven, serverless reporting engine scaling dynamically to support 10,000+ concurrent enterprise reports. Utilized AWS SQS and specialized worker instances to reduce generation bottlenecks by 45%.",
    tags: ["Microservices", "Golang", "AWS SQS", "Angular", "Serverless"],
    link: "https://www.siemens.com/en-us/products/building-x",
  },
  {
    name: "Engagely.ai — Agentic Routing",
    desc: "Architected an autonomous AI Agent routing engine and high-scale live chat platform with WebSocket channels, orchestrating 50,000+ active user-agent conversations concurrently. Built secure MCP (Model Context Protocol) connectors to fetch customer CRM data in real-time.",
    tags: ["AI Agents", "WebSockets", "MCP", "WebRTC", "Scalability"],
    link: "https://www.engagely.ai/",
  },
  {
    name: "Engagely.ai — Admin Portal",
    desc: "Led the redesign of a cognitive AI conversational platform's admin dashboard. Built rich analytics for agent pipelines and prompt engineering hubs. Reduced JS bundle sizes by 40% and improved dashboard load speeds by 1.8s.",
    tags: ["Angular", "Python", "Chart.js", "Performance Optimization"],
    link: "https://www.engagely.ai/product-unified-communication/",
  },
  {
    name: "Standard Bank — eBanking Core",
    desc: "Optimized core transaction processing engines handling $15M+ in daily transaction volume across South Africa & Nigeria, achieving 99.999% system uptime through active replication, modular microservices, and database sharding.",
    tags: ["Java", "Angular", "MySQL", "High Availability", "Enterprise"],
    link: "https://www.standardbank.co.za/southafrica/personal",
  },
  {
    name: "Prely Pharma ERP",
    desc: "Designed a modular, HIPAA-compliant pharmacy ERP system automating inventory replenishment and sales taxes, resulting in a 30% reduction in pharmacy processing overhead.",
    tags: ["Angular", "Node.js", "AWS", "Modular Architecture", "HIPAA"],
    link: "",
  },
  {
    name: "Pokedev",
    desc: "A weekend side-project — a searchable Pokédex app with client-side caching, lazy loading, and responsive design. A playground for exploring Svelte's reactivity model.",
    tags: ["Svelte", "REST API", "SPA"],
    link: "https://pokerepo.netlify.app/",
  },
];
